export default function productCards($container) {
    const cards = () => [...$container.querySelectorAll('.product-card')];

    const onRemove = (handler) => {
        cards().forEach(($productCard) => {
            $productCard.querySelector('.product-card-remove')?.addEventListener('click', event => {
                event.preventDefault();

                if (typeof handler === 'function') {
                    handler({
                        id: event.currentTarget.dataset.productclassid,
                        $productCard,
                        $productCards: cards()
                    });
                }
            });
        });
    };

    return {
        onRemove
    };
}